export default {"src":"/_next/static/media/search-gray.f02e00ea.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};